import script from "./BaseCheckboxNoBorder.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseCheckboxNoBorder.vue?vue&type=script&lang=ts&setup=true"

import "./BaseCheckboxNoBorder.vue?vue&type=style&index=0&id=126e72fa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126e72fa"]])

export default __exports__